import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";

export interface FailedJob {
  id: string;
  archivo_url: string;
  error_message: string | null;
  created_at: string;
  updated_at: string | null;
  job_metadata: Record<string, any> | null;
}

/**
 * Lista de jobs de extracción que terminaron en `error` y NO han sido rescatados.
 * Se usa para alimentar la "Bandeja de Procesamientos Fallidos" que habilita el Kill Switch OCR.
 */
export function useFailedJobs() {
  const { orgId } = useAuth();

  return useQuery({
    queryKey: ["failed-jobs", orgId],
    queryFn: async (): Promise<FailedJob[]> => {
      if (!orgId) return [];
      const { data, error } = await supabase
        .from("document_jobs" as any)
        .select("id, archivo_url, error_message, created_at, updated_at, job_metadata")
        .eq("org_id", orgId)
        .eq("status", "error")
        .order("updated_at", { ascending: false })
        .limit(50);
      if (error) throw error;
      // Filtrar los que YA fueron rescatados (kill_switch) o descartados manualmente (discarded)
      return ((data ?? []) as any[]).filter((j) => {
        const via = j?.job_metadata?.recovered_via;
        return via !== "kill_switch" && via !== "discarded";
      });
    },
    enabled: !!orgId,
    staleTime: 30_000,
  });
}
